import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {environment} from '../environments/environment';
import {Company} from '../models/company';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  refresh$ = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  createCompany(name: string, region: string) {
    const body = {name, region};
    return this.http.post<Company>(`${API}/api/companies`, body);
  }

  createCompanyForBusiness(name: string, phoneNumber: string, region: string, email: string, firstName: string, lastName: string, postalCode: string, country: string) {
    const body = {name, phoneNumber, region, email, firstName, lastName, postalCode, country};
    return this.http.post<Company>(`${API}/api/companies/business`, body);
  }

  getById(id: string) {
    return this.http.get<Company>(`${API}/api/companies/${id}`);
  }

  getBySlug(slug: string) {
    return this.http.get<Company>(`${API}/api/companies/${slug}/slug`);
  }

  findCompanies(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Company[]>(`${API}/api/companies`, {params});
  }

  findByUser(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Company[]>(`${API}/api/companies/user`, {params});
  }

  search(search: string, limit = 1000, skip = 0) {
    const params = {search, limit, skip};
    return this.http.get(`${API}/api/companies/search`, {params});
  }

  updateDetail(companyId: string, name: string, phoneNumber: string | undefined, region: string, allowedProductIds: string[], allowedPromotionId: string | null) {
    const body = {name, phoneNumber, region, allowedProductIds, allowedPromotionId};
    return this.http.put(`${API}/api/companies/${companyId}/detail`, body);
  }

  updateImage(companyId: string, imageId: string) {
    const body = {imageId};
    return this.http.put(`${API}/api/companies/${companyId}/image`, body);
  }

  updateInvoiceDetails(companyId: string, invoiceDetails: any) {
    const body = {invoiceDetails};
    return this.http.put(`${API}/api/companies/${companyId}/invoicedetails`, body);
  }

  updateLeaders(companyId: string, leaderIds: string[]) {
    const body = {leaderIds};
    return this.http.put(`${API}/api/companies/${companyId}/leaders`, body);
  }

  updateBookers(companyId: string, bookerIds: string[]) {
    const body = {bookerIds};
    return this.http.put(`${API}/api/companies/${companyId}/bookers`, body);
  }

  updateOptions(companyId: string, emailOptions: any, preference: any) {
    const body = {emailOptions, preference};
    return this.http.put(`${API}/api/companies/${companyId}/options`, body);
  }

  inviteMember(companyId: string, email: string, firstName: string, lastName: string, region: string) {
    const body = {email, firstName, lastName, region};
    return this.http.put(`${API}/api/companies/${companyId}/invite`, body);
  }

  kickMember(companyId: string, userId: string) {
    const body = {userId};
    return this.http.put(`${API}/api/companies/${companyId}/kick`, body);
  }

  deactivate(companyId: string) {
    return this.http.put(`${API}/api/companies/${companyId}/deactivate`, {});
  }

}
